module.exports = __webpack_public_path__ + "4506672303ec5836fd4ddc18954eecf8.svg";